import { getActiveSchool, isViewingDemoSchool } from './activeSchool';

/** Владелец / админ — полное управление расписанием, помещениями, слотами. */
export function canManageSchedule() {
    if (isViewingDemoSchool()) return false;
    const role = localStorage.getItem('role') || '';
    if (role === 'Owner' || role === 'Admin') return true;
    return getActiveSchool()?.accessRole === 'owner';
}

/** Ученик, сотрудник, тренер — только просмотр своих занятий. */
export function isScheduleViewOnly() {
    return !canManageSchedule();
}

/** Расписание в режиме ученика (заявки, план посещения). */
export function isStudentScheduleViewer() {
    const role = localStorage.getItem('role') || '';
    const ar = getActiveSchool()?.accessRole || '';
    return role === 'Member' || ar === 'member';
}

/** Показать переключатель «все мои школы» на странице расписания. */
export function canShowAllSchoolsScheduleToggle() {
    const role = localStorage.getItem('role') || '';
    const ar = getActiveSchool()?.accessRole || '';
    return role === 'Member' || role === 'Staff' || role === 'Coach'
        || ar === 'member' || ar === 'staff' || ar === 'coach';
}
